let dataDisplay = {
	1: {
		lineWidth: 1,
		originalMin: -62.5,
		originalMax: 62.5,
		maxZoom: 5,
		minZoom: -5,
		color: 'black',
		zoomable: true,
		upper: true,
		draggable: true,
		showDesat: false,
		showLocalExtreme: false
	},
	2: {
		lineWidth: 1,
		originalMin: -62.5,
		originalMax: 62.5,
		maxZoom: 5,
		minZoom: -5,
		color: 'black',
		zoomable: true,
		upper: true,
		draggable: true,
		showDesat: false,
		showLocalExtreme: false
	},
	3: {
		lineWidth: 1,
		originalMin: -62.5,
		originalMax: 62.5,
		maxZoom: 5,
		minZoom: -5,
		color: 'black',
		zoomable: true,
		upper: true,
		draggable: true,
		showDesat: false,
		showLocalExtreme: false
	},
	4: {
		lineWidth: 1,
		originalMin: -62.5,
		originalMax: 62.5,
		maxZoom: 5,
		minZoom: -5,
		color: 'black',
		zoomable: true,
		upper: true,
		draggable: true,
		showDesat: false,
		showLocalExtreme: false
	},
	5: {
		lineWidth: 1,
		originalMin: -62.5,
		originalMax: 62.5,
		maxZoom: 5,
		minZoom: -5,
		color: 'black',
		zoomable: true,
		upper: true,
		draggable: true,
		showDesat: false,
		showLocalExtreme: false
	},
	6: {
		lineWidth: 1,
		originalMin: -62.5,
		originalMax: 62.5,
		maxZoom: 5,
		minZoom: -5,
		color: 'black',
		zoomable: true,
		upper: true,
		draggable: true,
		showDesat: false,
		showLocalExtreme: false
	},
	7: {
		lineWidth: 1,
		originalMin: -62.5,
		originalMax: 62.5,
		maxZoom: 5,
		minZoom: -5,
		color: 'blue',
		zoomable: true,
		upper: true,
		draggable: false,
		showDesat: false,
		showLocalExtreme: false
	},
	8: {
		lineWidth: 1,
		originalMin: -62.5,
		originalMax: 62.5,
		maxZoom: 5,
		minZoom: -5,
		color: 'blue',
		zoomable: true,
		upper: true,
		draggable: false,
		showDesat: false,
		showLocalExtreme: false
	},
	9: {
		lineWidth: 1,
		originalMin: -62.5,
		originalMax: 62.5,
		maxZoom: 5,
		minZoom: -5,
		color: 'black',
		zoomable: true,
		upper: true,
		draggable: false,
		showDesat: false,
		showLocalExtreme: false
	},
	10: {
		lineWidth: 1,
		originalMin: -1,
		originalMax: 1,
		maxZoom: 5,
		minZoom: -5,
		color: 'red',
		zoomable: true,
		upper: true,
		draggable: false,
		showDesat: false,
		showLocalExtreme: false
	},
	11: { //Sound
		lineWidth: 1,
		originalMin: -0.5,
		originalMax: 0.5,
		maxZoom: 5,
		minZoom: -5,
		color: 'hotpink',
		zoomable: true,
		upper: false,
		draggable: false,
		showDesat: false,
		showLocalExtreme: false
	},
	12: {
		lineWidth: 1,
		originalMin: -0.96,
		originalMax: 0.96,
		maxZoom: 5,
		minZoom: -5,
		color: 'blue',
		zoomable: true,
		upper: false,
		draggable: true,
		showDesat: false,
		showLocalExtreme: false
	},
	13: {
		lineWidth: 1,
		originalMin: -416.665,
		originalMax: 416.665,
		maxZoom: 5,
		minZoom: -5,
		color: 'black',
		zoomable: true,
		upper: false,
		draggable: true,
		showDesat: false,
		showLocalExtreme: false
	},
	14: {
		lineWidth: 1,
		originalMin: -104.165,
		originalMax: 104.165,
		maxZoom: 5,
		minZoom: -5,
		color: 'green',
		zoomable: true,
		upper: false,
		draggable: false,
		showDesat: false,
		showLocalExtreme: false
	},
	15: {
		lineWidth: 1,
		originalMin: -104.165,
		originalMax: 104.165,
		maxZoom: 5,
		minZoom: -5,
		color: 'red',
		zoomable: true,
		upper: false,
		draggable: false,
		showDesat: false,
		showLocalExtreme: false
	},
	16: {
		lineWidth: 1,
		originalMin: 50,
		originalMax: 100,
		maxZoom: 0,
		minZoom: -10,
		fixedScale: true, // 固定 Y 軸範圍，訊號只在欄高比例內變動
		color: 'rgba(101, 39, 245, 1)',
		zoomable: false,
		upper: false,
		draggable: true,
		showDesat: true,
		showLocalExtreme: true
	},
	17: { //LimbL
		lineWidth: 1,
		originalMin: -100,
		originalMax: 100,
		maxZoom: 5,
		minZoom: -5,
		color: 'maroon',
		zoomable: true,
		upper: false,
		draggable: true,
		showDesat: false,
		showLocalExtreme: false
	},
	18: { //LimbR
		lineWidth: 1,
		originalMin: -100,
		originalMax: 100,
		maxZoom: 5,
		minZoom: -5,
		color: 'maroon',
		zoomable: true,
		upper: false,
		draggable: true,
		showDesat: false,
		showLocalExtreme: false
	},
	19: { //Pulse
		lineWidth: 1,
		originalMin: 0,
		originalMax: 90,
		fixedScale: true, // 固定 Y 軸範圍，訊號只在欄高比例內變動
		color: 'black',
		zoomable: false,
		upper: false,
		draggable: false,
		showDesat: false,
		showLocalExtreme: true
	},
	20: {
		lineWidth: 1,
		originalMin: -2.5,
		originalMax: 2.5,
		color: 'maroon',
		zoomable: false,
		upper: false,
		draggable: false,
		showDesat: false,
		showLocalExtreme: true
	},
	21: {
		lineWidth: 1,
		originalMin: 0,
		originalMax: 80,
		fixedScale: true, // 固定 Y 軸範圍，不隨資料動態縮放
		color: 'blue',
		zoomable: false,
		upper: false,
		draggable: true,
		showDesat: true,
		showLocalExtreme: true
	},
	22: {
		lineWidth: 1,
		originalMin: 0,
		originalMax: 200, // TcO2 固定上限 200，超出值 clamp 到頂部，不溢出到其他欄位
		fixedScale: true, // 固定 Y 軸範圍，不隨資料動態縮放，防止溢出到其他欄位
		color: 'blue',
		zoomable: false,
		upper: false,
		draggable: true,
		showDesat: true,
		showLocalExtreme: true
	}

}

export default dataDisplay